export default "__VITE_ASSET__DulKfRSh__"